export const CHUNK_SIZE_BYTES = 25 * 1024 * 1024;

export const PROGRESS_CIRCLE = {
    width: 72,
    strokeWidth: 5,
} as const;

export const PROGRESS_COLORS = {
    start: '#5CE1B9',
    end: '#12B76A',
    trail: 'rgba(148, 163, 184, 0.25)',
} as const;

export const ZIP_MIME_TYPE = 'application/zip';
export const ZIP_EXTENSION = '.zip';

export const DEFAULT_TRANSLATIONS = {
    uploadClick: 'Натисніть для завантаження файлу зі свого носія',
    uploadDrag: 'або перетягніть його сюди',
    supportedFormats: 'Підтримуються формати: ZIP',
    uploadFailedTitle: 'Помилка завантаження!',
    uploadFailedCommon: "Щось пішло не так. Перевірте з'єднання та спробуйте ще раз.",
    zipOnly: 'Будь ласка, завантажте файл у форматі ZIP.',
    uploadSuccess: 'Файл завантажено успішно!',
    tryAgain: 'Спробувати ще раз',
    noFiles: 'Файлів ще не завантажено',
    removeFile: 'Видалити файл',
    selectFile: 'Обрати файл',
    upload: 'Завантажити',
} as const;

export const TRANSLATION_KEYS = {
    uploadClick: 'applications.wizard.upload_click',
    uploadDrag: 'applications.wizard.upload_drag',
    supportedFormats: 'applications.wizard.supported_formats',
    uploadFailedTitle: 'applications.wizard.upload_failed_title',
    uploadFailedCommon: 'applications.wizard.upload_failed_common',
    zipOnly: 'applications.wizard.upload_zip_only',
    uploadSuccess: 'applications.wizard.upload_success_title',
    tryAgain: 'applications.wizard.upload_try_again',
    noFiles: 'applications.wizard.no_files',
    removeFile: 'applications.wizard.remove_file',
    selectFile: 'select_a_file',
    upload: 'upload',
} as const;
